
import { Component, Vue, Prop } from 'nuxt-property-decorator'
import { PlaybackStatus } from './utils/EngineService'
import { WebPlayerThemeUtil } from './utils/WebPlayerThemeUtil'
import { PlatformSettingsWeb } from '~/api'

@Component
export default class WebPlayerProgressBar extends Vue {
  @Prop() audioProgress!: number
  @Prop() playStatus!: PlaybackStatus
  @Prop() platformSettings!: PlatformSettingsWeb

  PlaybackStatus = PlaybackStatus
  label = '⏪︎ Press to Fast Forward or Rewind ⏩︎'

  calculateBrightness(color: string): number {
    const rgb = color.match(/\d+/g)?.map(Number) || [255, 255, 255]
    const [r, g, b] = rgb
    return 0.299 * r + 0.587 * g + 0.114 * b // Luminance formula
  }

  updateTextColor(): void {
    const element = this.$el! as HTMLElement

    const foregroundBrightness = this.calculateBrightness(
      this.headerStyle['--seeker-bar-color']!
    )
    const backgroundBrightness = this.calculateBrightness(
      this.headerStyle['--header-background']!
    )

    const foregroundTextColor = foregroundBrightness > 128 ? 'black' : 'white'
    const backgroundtextColor = backgroundBrightness > 128 ? 'black' : 'white'

    element.style.setProperty('--foreground-text-color', foregroundTextColor)
    element.style.setProperty('--background-text-color', backgroundtextColor)
  }

  mounted() {
    this.updateTextColor()
  }

  get headerStyle() {
    return WebPlayerThemeUtil.headerStyle(this.platformSettings)
  }
}
